// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"CardContent_cardContent__XN5sd","first":"CardContent_first__wEXJ3","last":"CardContent_last__QRcDc"};